module.exports = __webpack_public_path__ + "static/freeCodeCamp-404-fa7cff9406d8c1a72ae5ffeadd315202.svg";